import React, { startTransition } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { SmartBlock } from './SmartBlock';
import { StaminaCore } from './StaminaCore';
import { UnitStatsPortrait } from './UnitStatsPortrait';
import { useBattleStore } from '@/store/useBattleStore';
import './BottomPanel.css';
import { BattleStatus, FactionType } from '@/core/types/battle.types';
import { CentralPlaceholder } from '@/view/ui/battle/BottomPanel/CentralPlaceholder';

export function BottomPanel() {
    const selectedUnitId = useBattleStore(s => s.selectedUnitId);
    const selectedSkillId = useBattleStore(s => s.selectedSkillId);
    const inspectedUnitId = useBattleStore(s => s.inspectedUnitId);
    const status = useBattleStore(s => s.status);
    const selectedPath = useBattleStore(useShallow(s => s.selectedPath));

    const unit = useBattleStore(s =>
        selectedUnitId ? s.units.get(selectedUnitId) ?? null : null
    );
    const inspectedUnit = useBattleStore(s =>
        inspectedUnitId ? s.units.get(inspectedUnitId) ?? null : null
    );

    const [priority, setPriority] = React.useState<'unit' | 'path' | null>(null);

    React.useEffect(() => {
        startTransition(() => {
            setPriority(inspectedUnitId ? 'unit' : selectedPath ? null : null);
        });
    }, [inspectedUnitId]);

    React.useEffect(() => {
        startTransition(() => {
            setPriority(selectedPath ? 'path' : inspectedUnitId ? 'unit' : null);
        });
    }, [selectedPath]);

    if (!unit) return <div className="bottom-panel" />;

    const skill = selectedSkillId
        ? unit.skills.find(s => s.id === selectedSkillId) ?? null
        : null;

    const previewCost = skill?.cost ?? selectedPath?.cost ?? 0;
    const isEnemy = unit.faction === FactionType.Enemy;
    const isPaused = status === BattleStatus.Paused;

    const finalInspectedUnit = priority === 'unit' ? inspectedUnit : null;
    const finalTerrain = priority === 'path' ? selectedPath?.lastStep?.terrain : null;

    const renderCentralContent = () => {
        if (isPaused) return <CentralPlaceholder text="PAUSED" />;
        if (isEnemy) return <CentralPlaceholder text="ENEMY TURN" />;
        return (
            <StaminaCore
                unitName={unit.unitName}
                unitId={unit.unitId}
                currentStamina={unit.currentStamina}
                maxStamina={unit.stats.stamina}
                previewCost={previewCost}
            />
        );
    };

    return (
        <div className="bottom-panel">
            {isPaused ? <div /> : <UnitStatsPortrait unit={unit} />}
            {renderCentralContent()}
            {isPaused ? <div /> : (
                <SmartBlock
                    skill={skill}
                    unit={unit}
                    terrain={finalTerrain}
                    inspectedUnit={finalInspectedUnit}
                />
            )}
        </div>
    );
}